import {
  Directive,
  Injector,
  Optional
} from '@angular/core';

import { IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'app-top-nav';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-top-nav',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmTopNav]',
  providers: [
    provideAsWidgetRef(TopNavComponent)
  ],
  exportAs: 'wmTopNav',
  standalone: true
})
export class TopNavComponent extends StylableComponent {
  static initializeProps = register('wm-top-nav');

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

